import React from 'react'
import { Button } from '../button/Button'
import { Container } from '../layout/Container'
import { ButtonStylesEnum } from 'types/buttonStylesEnum'

// Fallback UI rendered by the top-level Sentry.ErrorBoundary when a render
// error escapes React's tree. Kept intentionally simple/self-contained (no
// translations, no external state) so it can still render if the app's own
// providers (i18n, redux, etc.) are the ones that failed.
export const ErrorFallback = () => (
    <Container>
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '80vh',
                textAlign: 'center',
                padding: '24px'
            }}
        >
            <h2>Something went wrong</h2>
            <p>
                We&apos;re sorry, an unexpected error occurred. Please try
                reloading the page.
            </p>
            <Button
                style={ButtonStylesEnum.PRIMARY}
                onClick={() => window.location.reload()}
            >
                Reload
            </Button>
        </div>
    </Container>
)
